<template>
  <section>
    <div class="auth-require" v-if="blur">
      <div>
        <p>
          <span class="orange bold action" v-on:click="loginAction">ล็อกอิน</span> หรือ
          <span class="orange bold action" v-on:click="registerAction">สมัครสมาชิก</span>
        </p>
        <p>
          เพื่อดูข้อมูลหุ้นเชิงลึก
          <span class="red">ฟรี!</span>
        </p>
      </div>
    </div>
    <div v-if="list" :class="{blur : blur}" class="stockholder-wrapper">
      <div class="row topic">
        <div class="name-wrapper"></div>
        <div class="amount">จำนวนหุ้น</div>
        <div class="percentage" style="font-size: 12px; color: #444444;">%</div>
      </div>
      <div
        class="row cursor-pointer"
        v-for="(person,index) in list"
        :key="index"
        data-action="stock_shareholder"
        @click="modalFunction(index)"
      >
        <div class="name-wrapper">
          <div class="name-index">{{ index+1 }}.</div>
          <div class="name">{{ person.name }}</div>
        </div>
        <div class="amount">{{ person.amount | number }}</div>
        <div class="percentage">{{ person.percentage }}%</div>
        <div class="icon">
          <i class="fas fa-angle-right"></i>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";

export default {
  name: "table-shareholder",
  props: {
    // Props to receive
    // list ( type: Array, required: true, description: 'List of shareholder name which has name, amount, percentage')
    // modalFunction ( type: Function, required: false, description: 'Function for open stockholder modal (also need index)')
    blur: {
      type: Boolean,
      required: false,
      default: true
    },
    list: {
      required: true
    },
    modalFunction: {
      type: Function,
      default: () => {}
    }
  },
  methods: {},
  filters: {
    number: function(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      return "N/A";
    }
  }
};
</script>

<style lang='scss' scoped>
.blur {
  filter: blur(3px);
}

.action {
  cursor: pointer;
}

.auth-require {
  width: 350px;
  height: 147px;
  text-align: center;
  vertical-align: middle;
  border-radius: 4px;
  background-color: #f1f1f1;
  position: absolute;
  z-index: 1;
  left: calc(50% - 175px); // ( 350px - 190px )/2
  top: calc(50% - 73.5px);
  display: table;
  font-size: 16px;
  border: #d7d7d7 1px solid;

  div {
    display: table-cell;
    vertical-align: middle;
    p {
      margin: 0;
    }

    .bold {
      font-weight: bold;
    }

    .orange {
      color: $base-orange;
    }

    .red {
      color: $base-red;
    }
  }
}

.stockholder-wrapper {
  .row {
    padding: 15px 10px;
    font-size: 16px;
    color: $color-normal-text;
    border-bottom: 1px solid $light-grey;
    .name-wrapper {
      pointer-events: none;
      width: 60%;
      display: inline-block;
      .name-index {
        margin-right: 10px;
        display: inline-block;
        vertical-align: top;
        width: 20px;
      }
      .name {
        display: inline-block;
        width: inherit;
      }
    }
    .amount {
      width: 20%;
      text-align: right;
      display: inline-block;
      vertical-align: top;
    }
    .percentage {
      width: 15%;
      text-align: right;
      display: inline-block;
      vertical-align: top;
    }
    .icon {
      width: 5%;
      color: $color-secondary-text;
      text-align: right;
      display: inline-block;
      vertical-align: top;
    }
    &:last-of-type {
      border-bottom: 1px dotted $finno-orange;
    }
    &.topic {
      font-size: 18px;
      color: $grey;
      border-bottom: 1px dotted $finno-orange;
      cursor: auto;
      &:hover {
        background-color: transparent;
      }
    }
    &:hover {
      background-color: $highlight-grey;
    }
  }
}

@media screen and (max-width: 560px) {
  .stockholder-wrapper {
    .row {
      .name-wrapper {
        width: 55%;
      }
      .amount {
        width: 35%;
        text-align: left;
      }
      .percentage {
        width: 7%;
      }
      .icon {
        width: 3%;
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .stockholder-wrapper {
    .row {
      padding: 5px;
      .name-wrapper {
        width: 80%;
        font-size: 12px;
      }
      .amount {
        display: none;
      }
      .percentage {
        width: 13%;
        font-size: 11px;
      }
      .icon {
        width: 7%;
      }
    }
  }
}
</style>
